var JCS_WIDGET_DOMAIN_PROD = 'https://jcs-chat-widget.atlassian.com';
var JCS_WIDGET_DOMAIN_STG = 'https://jcs-chat-widget.stg.atlassian.com';
export var getPreconnectHref = function getPreconnectHref(site) {
  return /jira-dev\.com/.test(site) ? JCS_WIDGET_DOMAIN_STG : JCS_WIDGET_DOMAIN_PROD;
};